import script from "./SkillsAll.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsAll.vue?vue&type=script&setup=true&lang=js"

import "./SkillsAll.vue?vue&type=style&index=0&id=6d66ffc1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d66ffc1"]])

export default __exports__